import PictureLoader from './PictureLoader'
export default PictureLoader
